export default "__VITE_ASSET__CIzE0ux7__"